// src/hooks/useSubmitInput.js
import axios from 'axios';
import { getBaseUrl } from '../utils/request';

const useSubmitInput = ({sessionId, authToken,organisationId }) => {
    return async (input) => {
        try {
            const response = await axios.post(
                `${getBaseUrl()}/vedai/main?input=${encodeURIComponent(input)}`,
                { withCredentials: true },
                {
                    headers: {
                        'X-DEVICE-ID': sessionId,
                        'x-ofb-token': authToken,
                        'X-OFB-ORGANISATION': organisationId
                    }
                }
            );
            return response.data.data;
        } catch (error) {
            console.error("Error in useSubmitInput:", error);
            throw error;
        }
    };
};

export default useSubmitInput;
